import { render, staticRenderFns } from "./SupplementSelection.vue?vue&type=template&id=6bf76e28&scoped=true"
import script from "./SupplementSelection.vue?vue&type=script&lang=js"
export * from "./SupplementSelection.vue?vue&type=script&lang=js"
import style0 from "./SupplementSelection.vue?vue&type=style&index=0&id=6bf76e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf76e28",
  null
  
)

export default component.exports